import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-coe-approval',
  templateUrl: './coe-approval.component.html',
  styleUrls: ['./coe-approval.component.css'],
})
export class CoeApprovalComponent implements OnInit {
  private ApprovalApi = environment.url + environment.coeapproval;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<CoeApprovalComponent>
  ) {
    this.datas = data;
    this.reasondata = this.datas._id;
  }
  reasondata;
  ngOnInit(): void {}

  userID = sessionStorage.getItem('userId');
  ApplicationId = sessionStorage.getItem('applicationId');
  datas;

  approval() {
    let req = {
      id: this.ApplicationId,
      userId: this.userID,
      status: this.reasondata,
    };
    this.makeapi.method(this.ApprovalApi, req, 'post').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      if (data.responseStatus == 'Success') {
        this.notify.notifysuccess(data.responseMessage);
        this.dialogRef.close();
      }
    });
  }
  cancelReason() {
    this.dialogRef.close();
  }
}
